import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, forwardRef } from "react";
import AgGridTable from "../utilities/AgGridTable";
import { CheckBox } from "@mui/icons-material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useImperativeHandle } from "react";

const ReconciliationGrid =forwardRef((props , ref) => {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const ReconciliationURL = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.reconciliation}`;

  const checkRecon = (params) => {
    const isChecked = !params.value;
    return (
      <CheckBox
        size="small"
        value={isChecked}
        checked={isChecked}
        sx={{ "& .MuiSvgIcon-root": { fontSize: 10 } }}
        disabled={true}
      />
    );
  };

  const handleClickRedireact = async(params) => {
    if (params <= 1) {
      const getCurrentVoucher = await OAuthService.getList(voucherTypesUrl +`/search/findByShortKey?shortKey=JV`);
      if(getCurrentVoucher?.data){

        navigate('/addVoucher' ,{ state : {voucherType:getCurrentVoucher?.data?._links?.self?.href?.split('/').pop(),voucherTypeDesc:"Journal Voucher"}} )
      }else{

        navigate('/addVoucher' ,{ state : {voucherTypeDesc:"Journal Voucher"}} )
      }
    } else {
      setDialogOpen(true);
    }
  };
  
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  
  const handleMailSend = () => {};

  const matchingInvoices = async () => {
    const data = await OAuthService.getList(
      ReconciliationURL + "/getMatchingInvoicesFromUnpaidList"
    );
    setABNoRowData(data?.data);
  };



  const getDifference = (params) => {
    return params.data.difference && params?.data?.difference !== 0 ? (
      <Button
        size="small"
        className="p-0"
        onClick={() => handleClickRedireact(params.data.difference)}
      >
        <FuseSvgIcon>material-solid:assignment</FuseSvgIcon>
      </Button>
    ) : (
      ""
    );
  };
  const [ABNoRowData, setABNoRowData] = useState([]);
  const [voucherType , setVoucherType] = useState()
  const [totalInvoiceAmount , setTotalInvoiceAmount] = useState(0)
  const [payableInvoiceAmount , setPayableInvoiceAmount] = useState(0)
  const [totalDifference , setTotalDifference] = useState(0)
  const voucherTypesUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucherTypes}`;
  
  const showFixedValue = (props) => {
    const options = {
      style: "decimal", // Other options: 'currency', 'percent', etc.
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    return (
      <span>
        <p>
          {props?.value
            ? Number(props?.value).toLocaleString("en-US", options)
            : 0.0}
        </p>
      </span>
    );
  };

  useEffect(() => {
    const totalAmount =
    ABNoRowData &&
    ABNoRowData.reduce((total, invoice) => total + invoice.invoiceAmount, 0);

    setTotalInvoiceAmount(totalAmount);

  const payableAmount =
    ABNoRowData &&
    ABNoRowData.reduce((total, invoice) => total + invoice.payableAmount, 0);

    setPayableInvoiceAmount(payableAmount)
  const totalDiff =
    ABNoRowData &&
    ABNoRowData.reduce((total, invoice) => total + invoice.difference, 0);

    setTotalDifference(totalDiff)
  },[ABNoRowData])
  const [ABNoColumnDefs, setABNoColumnDefs] = useState([
    { field: "abNumber", headerName: "AB No" },
    { field: "invoiceNo", headerName: "NK Invoice No" },
    { field: "invoiceAmount", headerName: "Amount", cellRenderer:showFixedValue },
    { field: "vandorInvoiceNo", headerName: "NFZE Invoice" },
    { field: "invoiceAmount", headerName: "Amount", cellRenderer:showFixedValue },
    { field: "difference", headerName: "Difference", cellRenderer:showFixedValue },
    { field: "isReconcile", headerName: "Recon?", cellRenderer: checkRecon },
    { field: "payableAmount", headerName: "Payable Amount", cellRenderer:showFixedValue },
    { field: "action", headerName: "Action", cellRenderer: getDifference },
  ]);

  
  useEffect(() => {
    if (props.tabValue === 2) {
      matchingInvoices();
    }
  }, [props.tabValue]);

    const saveReconcilition = async() => {
      // let listData = ABNoRowData?.map((data)=>{
      //   data.description

      //   return data
      // })
      const getCurrentVoucher = await OAuthService.getList(voucherTypesUrl +`/search/findByShortKey?shortKey=BP`);
      if(getCurrentVoucher?.data){
        navigate('/addVoucher' ,{ state : {voucherType:getCurrentVoucher?.data?._links?.self?.href?.split('/').pop(),voucherTypeDesc:"Bank Payment"}} )
      }else{
        navigate('/addVoucher' ,{ state : {voucherTypeDesc:"Bank Payment"}} )
      }
    }

    useImperativeHandle(ref, () => ({
      saveReconcilition: saveReconcilition,
      handleRefreshReconcile: handleRefreshReconcile
  }))

  const handleRefreshReconcile = async (event, fromDate,toDate) => {
    const refreshReconcile = await OAuthService.getList(
      ReconciliationURL +
        "/refreshReconcilation" +
        `?dateFrom=${fromDate}&dateTo=${toDate}`
    );
    refreshReconcile?.data && setABNoRowData(refreshReconcile?.data)
    
    const totalAmount =
    refreshReconcile?.data &&
    refreshReconcile?.data.reduce((total, invoice) => total + invoice.invoiceAmount, 0);

    setTotalInvoiceAmount(totalAmount);

  const payableAmount =
  refreshReconcile?.data &&
  refreshReconcile?.data.reduce((total, invoice) => total + invoice.payableAmount, 0);

    setPayableInvoiceAmount(payableAmount)
    const totalDiff =
    refreshReconcile?.data &&
    refreshReconcile?.data.reduce((total, invoice) => total + invoice.difference, 0);

    setTotalDifference(totalDiff)
  };
  
  const options = {
    style: "decimal", // Other options: 'currency', 'percent', etc.
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  return (
    <>
      <AgGridTable rowData={ABNoRowData} columnDefs={ABNoColumnDefs} />
      <Grid container spacing={2} className="mt-3">
        <Grid item xs={1}></Grid>
        <Grid item xs={3} className="flex items-center">
          <label className="min-w-fit">Total Amount</label>
          <TextField
            className="w-[100%] ml-10"
            name="amount"
            value={ABNoRowData && totalInvoiceAmount ? Number(totalInvoiceAmount).toLocaleString("en-US", options) : 0}
            size="small"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={3} className="flex items-center">
          <label className="min-w-fit">Total Amount</label>
          <TextField
            className="w-[100%] ml-10"
            name="amount"
            value={ABNoRowData && totalInvoiceAmount ? Number(totalInvoiceAmount).toLocaleString("en-US", options) : 0}
            size="small"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={2} className="flex items-center">
          <label className="min-w-fit">Total Difference</label>
          <TextField
            className="w-[100%] ml-10"
            name="amount"
            value={ABNoRowData && totalDifference ? Number(totalDifference).toLocaleString("en-US", options) : 0}
            size="small"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={3} className="flex items-center">
          <label className="min-w-fit">Total Payable Amount</label>
          <TextField
            className="w-[100%] ml-10"
            name="payableAmount"
            value={ABNoRowData && payableInvoiceAmount ? Number(payableInvoiceAmount).toLocaleString("en-US", options) : 0}
            size="small"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleDialogClose}
        open={dialogOpen}
      >
        <Toolbar className="flex w-full justify-between">
          <Typography variant="subtitle1" color="inherit">
            Mail Confirmation
          </Typography>
          <Button onClick={handleDialogClose}>
            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
          </Button>
        </Toolbar>
        <DialogContent>
          <DialogContentText>
            Do you want to send mail to customer?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="warning"
            className="mb-3 ml-3 font-bold"
            onClick={handleMailSend}
          >
            Yes
          </Button>
          <Button
            color="inherit"
            onClick={handleDialogClose}
            className="mb-3 font-bold"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});
export default ReconciliationGrid;
